import { useCallback, useEffect, useState } from 'react';
import { Link, NavLink, useParams } from 'react-router';
import { api, cn, Spinner } from '@karozik/ui';
import { STATUS_LABEL, type AdminEvent } from '../types';
import { LiveTab } from './LiveTab';
import { ShareTab } from './ShareTab';
import { GuestsTab } from './GuestsTab';
import { PhotosTab } from './PhotosTab';
import { PoolTab } from './PoolTab';
import { SettingsTab } from './SettingsTab';
import { RecapTab } from './RecapTab';

const TABS = [
  { id: 'live', label: '🎛️ Direct' },
  { id: 'partage', label: '📲 Partage' },
  { id: 'invites', label: '👥 Invités' },
  { id: 'photos', label: '📷 Photos' },
  { id: 'pool', label: '💿 Pool' },
  { id: 'reglages', label: '⚙️ Réglages' },
  { id: 'recap', label: '🏆 Récap' },
] as const;

export function EventPage() {
  const { id = '', tab = 'live' } = useParams();
  const [event, setEvent] = useState<AdminEvent | null>(null);
  const reload = useCallback(() => {
    void api<AdminEvent>(`/api/admin/events/${id}`).then(setEvent);
  }, [id]);
  useEffect(reload, [reload]);

  if (!event) {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-3xl px-4 pb-16">
      <header className="sticky top-0 z-20 -mx-4 bg-night/90 px-4 pt-4 pb-2 backdrop-blur">
        <div className="flex items-center gap-3">
          <Link to="/" className="text-ink-dim">
            ←
          </Link>
          <h1 className="min-w-0 flex-1 truncate text-lg font-bold">{event.name}</h1>
          <span className={cn('rounded-full px-2.5 py-0.5 text-xs font-bold', event.status === 'live' ? 'bg-lime text-night' : 'bg-surface-3 text-ink-dim')}>
            {STATUS_LABEL[event.status]}
          </span>
          <a href={`/player/${event.id}`} target="_blank" rel="noreferrer" className="bg-gradient-neon rounded-xl px-3 py-1.5 text-sm font-bold">
            ▶ Lecteur
          </a>
        </div>
        <nav className="-mx-1 mt-3 flex gap-1 overflow-x-auto">
          {TABS.map((t) => (
            <NavLink
              key={t.id}
              to={`/events/${event.id}/${t.id}`}
              className={cn('shrink-0 rounded-xl px-3 py-2 text-sm font-semibold', tab === t.id ? 'bg-surface-3 text-ink' : 'text-ink-dim')}
            >
              {t.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <div className="mt-4">
        {tab === 'live' && <LiveTab event={event} />}
        {tab === 'partage' && <ShareTab event={event} onChange={setEvent} />}
        {tab === 'invites' && <GuestsTab event={event} />}
        {tab === 'photos' && <PhotosTab event={event} />}
        {tab === 'pool' && <PoolTab event={event} onChange={reload} />}
        {tab === 'reglages' && <SettingsTab event={event} onChange={setEvent} />}
        {tab === 'recap' && <RecapTab event={event} />}
      </div>
    </div>
  );
}
